// extracted by mini-css-extract-plugin
export default {"chart":"M_dB","fullscreen":"M_c2","close":"M_dC"};